import { useCallback, useEffect, useState } from "react";
import { useDispatch } from "react-redux";

import { goToLink } from "@actions/common";
import { showAlert as showAlertAction } from "@components/alert/action";
import { useBettoFavoriteGames } from "@pages/casino/hooks/useBettoFavoriteGames";
import { openGame } from "@pages/casino/utils";

const filterOptions = [
	{
		label: "CASINO",
		value: false,
		key: "casino",
		count: 0,
	},
	{
		label: "LIVE",
		value: true,
		key: "live_casino",
		count: 0,
	},
];

const useBettoFavoritesController = ({ loadFavorites = true } = {}) => {
	const [selectedFilters, setSelectedFilters] = useState([]);
	const dispatch = useDispatch();

	const {
		favoriteGames: queryFavoriteGames,
		isLoading: isFavoritesLoading,
		removeFavorite,
	} = useBettoFavoriteGames({
		skip: !loadFavorites,
	});

	const [favoriteGames, setFavoriteGames] = useState([]);

	useEffect(() => {
		if (queryFavoriteGames) {
			setFavoriteGames(queryFavoriteGames);
		}
	}, [queryFavoriteGames]);

	const redirect = useCallback(
		(...args) => {
			dispatch(goToLink(...args));
		},
		[dispatch]
	);

	const showAlert = useCallback(
		(...args) => {
			dispatch(showAlertAction(...args));
		},
		[dispatch]
	);

	const handleRemoveFavorite = useCallback(
		async (gameId) => {
			setFavoriteGames((prev) => prev.filter((game) => String(game?.id) !== String(gameId)));
			try {
				await removeFavorite(gameId);
			} catch (error) {
				console.error(error);
				setFavoriteGames(queryFavoriteGames);
			}
		},
		[removeFavorite, queryFavoriteGames]
	);

	const handleSelectFilter = (value) => {
		const option = filterOptions.find((x) => x.value === value);
		setSelectedFilters([{ ...option, section: "gameType" }]);
	};

	const handleGameCardClick = (game, type) => {
		openGame(game, redirect, showAlert, {}, type);
	};

	const handleRemoveFilter = (filter) => {
		setSelectedFilters((current) => current.filter((x) => x.key !== filter.key));
	};

	const handleRemoveAllFavorites = () => {
		setSelectedFilters([]);
	};

	return {
		state: {
			favoriteGames,
			isFavoritesLoading,
			selectedFilters,
			allFavoriteGames: favoriteGames,
			filterOptions,
		},
		handlers: {
			handleRemoveFavorite,
			handleGameCardClick,
			handleRemoveAllFavorites,
			handleRemoveFilter,
			handleSelectFilter,
		},
	};
};

export default useBettoFavoritesController;
